import { createSlice, nanoid } from "@reduxjs/toolkit";
import { capitalize } from "lodash";
const createService = (name = "") => ({
  system_id: undefined,
  name: name,
  category: null,
  serviceOptions: [],
  newServiceOptions: [],
  currentServiceOption: "",
});

const initialState = createService();

const createServiceOption = () => ({
  id: nanoid(),
  name: "",
  description: "",
  comments: "",
});

export const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    setService: (state, action) => {
      state["system_id"] = action.payload.system_id;
      state["name"] = action.payload.name;
      state["category"] = { name: capitalize(String(action.payload.category)) };
    },
    handleChange: (state, action) => {
      state[action.payload.name] = action.payload.value;
    },
    setServiceOptions: (state, action) => {
      state["serviceOptions"] = action.payload;
    },
    clearServiceOptions: (state, action) => {
      state["newServiceOptions"] = [];
      state["currentServiceOption"] = "";
    },
    addServiceOption: (state, action) => {
      const serviceOption = createServiceOption();
      state.newServiceOptions.push(serviceOption);
      state["currentServiceOption"] = serviceOption.id;
    },
    updateServiceOption: (state, action) => {
      state["newServiceOptions"] = state["newServiceOptions"].map(
        (serviceOption) => {
          if (serviceOption.id === action.payload.id) {
            return {
              ...serviceOption,
              [action.payload.key]: action.payload.value,
            };
          } else return serviceOption;
        }
      );
      if (action.payload.hasData) {
        state["serviceOptions"] = state["serviceOptions"].map(
          (serviceOption) => {
            if (serviceOption.system_id === action.payload.id) {
              return {
                ...serviceOption,
                [action.payload.key]: action.payload.value,
              };
            } else return serviceOption;
          }
        );
      }
      state["currentServiceOption"] = action.payload.id;
    },
    removeServiceOption: (state, action) => {
      state["serviceOptions"] = state["serviceOptions"].filter(
        (serviceOption) => serviceOption["option"] !== action.payload.option
      );
    },
  },
});
